import { AnimationBaseController, IAnimationControllerConfiguration, Inject } from '@denishussar/html5-game-engine';
import { ButtonController, IButtonControllerOptions } from '../../../Common/ButtonController';
import { GameLogic } from '../../../Logic/GameLogic';
import { ShopLogic } from '../../../Logic/ShopLogic';
import { ProductModel, ProductModifiersEnum, ProductStickerEnum } from '../../../Services/CloudDB/Contract';

export enum ShopLifeItemBenefitTypeEnum {
    none,
    benefit,
    playerChoice,
}

export interface IShopSmallCardControllerOptions {}

export class ShopSmallCardController extends AnimationBaseController {
    $model: ProductModel;

    public constructor(
        @Inject private _options: IShopSmallCardControllerOptions,
        @Inject private _gameLogic: GameLogic,
        @Inject private _shopLogic: ShopLogic,
    ) {
        super('ShopSmallCardController');
    }

    protected getConfiguration(): IAnimationControllerConfiguration {
        return <IAnimationControllerConfiguration>{
            childControllers: {
                btn_buy: {
                    instanceName: 'button',
                    controller: ButtonController,
                    options: <IButtonControllerOptions>{
                        label: (-this.$model.modifiers.coins).toString(),//todo: add method for extract price?
                        onClick: (status: boolean) => {
                            this._shopLogic.handleClickBuyButton(this.$model);
                        },
                    },
                },
                btn_get_from_friend: {
                    instanceName: 'btn_get_from_friend',
                    controller: ButtonController,
                    options: <IButtonControllerOptions>{
                        onClick: (status: boolean) => {
                            this._shopLogic.handleClickGetLifeFromFriend();
                        },
                    },
                },
            },
            modelWatch: {
                id: () => this.updateState(),
                type: () => this.updateState(), //todo: отрефакторить под требования логики, чтобы убрать лишние отрисовки (подмена карты)
                modifiers: () => this.updateState(),
            },
        };
    }

    protected onInitialize() {
        this.updateState();
    }

    private updateState(model = this.$model) {
        this.gotoAndStop(model.type);
        for (let key in model.modifiers) {
            //todo: rework!
            if (key === ProductModifiersEnum.unlimLives) {
                const time = model.modifiers[key];
                const normalize = (num) => (num < 10) ? '0' + num : num;
                const hours = Math.floor(time / 3600000);
                const minutes = normalize(Math.floor((time % 3600000) / 60000));
                const seconds = normalize(Math.floor((time % 60000)));
                let text = '';
                if (hours) text += `${hours}:`;
                if (minutes) text += `${minutes}:`;
                if (seconds) text += `${seconds}`;
                this.setTextByQuery(`txt_${key}`, text);
            } else this.setTextByQuery(`txt_${key}`, model.modifiers[key]);
        }

        //sticker
        if (model.sticker && model.stickerInfo) {
            this.gotoAndStopByQuery('benefit', model.sticker);
            this.setTextByQuery('benefit.txt_sticker_value', model.stickerInfo);
        } else {
            this.gotoAndStopByQuery('benefit', ProductStickerEnum.none);
        }
    }
}
